export default __webpack_public_path__ + "static/media/Wordpress_Peartree1_Ltd.61f91d1d.png";